import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AppState} from '../../../../shared/store/store';
import {Store} from '@ngrx/store';
import {reportUpdateSettings} from '../../../../shared/store/report/report.actions';

@Component({
  selector: 'app-parameters-dialog',
  templateUrl: './parameters-dialog.component.html',
  styleUrls: ['./parameters-dialog.component.scss']
})
export class ParametersDialogComponent implements OnInit, AfterViewInit {

  public keepSingleEventsCtrl: FormControl = new FormControl(null);
  public form: FormGroup = new FormGroup({
    before_events: new FormControl(null, [Validators.min(1), Validators.max(2), Validators.required]),
    after_events: new FormControl(null, [Validators.min(1), Validators.max(2), Validators.required]),
    keep_single_events: this.keepSingleEventsCtrl
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: { keep_single_events: boolean, after_events: number, before_events: number },
    public readonly dialogRef: MatDialogRef<ParametersDialogComponent>,
    private readonly _store: Store<AppState>
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.initForm();
  }

  protected initForm(): void {
    this.form.enable();
    this.form.get('before_events').setValue(this._data.before_events);
    this.form.get('after_events').setValue(this._data.after_events);
    this.form.get('keep_single_events').setValue(this._data.keep_single_events);
  }

  public onSubmit(): void {
    this._store.dispatch(reportUpdateSettings({
      settings: this.form.value
    }));
    this.dialogRef.close();
  }
}
